var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKyrgyzstan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4189C24.8366 32.4189 32 25.2555 32 16.4189C32 7.58239 24.8366 0.418945 16 0.418945C7.16344 0.418945 0 7.58239 0 16.4189C0 25.2555 7.16344 32.4189 16 32.4189Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8246 16.4187L20.6274 17.9225L22.3299 21.0192L18.8579 20.3549L18.4181 23.8622L15.9997 21.2828L13.5814 23.8622L13.1415 20.3549L9.66974 21.0191L11.3722 17.9224L8.17493 16.4187L11.3722 14.9149L9.66974 11.8181L13.1414 12.4825L13.5816 8.97517L15.9997 11.5546L18.4183 8.97517L18.8579 12.4825L22.3301 11.8181L20.6274 14.915L23.8246 16.4187Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 21.2886C18.6894 21.2886 20.8696 19.1084 20.8696 16.419C20.8696 13.7296 18.6894 11.5495 16.0001 11.5495C13.3107 11.5495 11.1305 13.7296 11.1305 16.419C11.1305 19.1084 13.3107 21.2886 16.0001 21.2886Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5653 16.4189C13.448 16.4189 13.3322 16.4249 13.2179 16.4363C13.2221 17.1108 13.4661 17.7281 13.8691 18.2076C14.0841 17.6291 14.4051 17.1015 14.8099 16.65C14.4233 16.5013 14.0038 16.4189 13.5653 16.4189Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0642 19.0398C15.3567 19.1443 15.6716 19.2016 16.0001 19.2016C16.3286 19.2016 16.6436 19.1443 16.9361 19.0398C16.7766 18.414 16.4475 17.8554 16.0001 17.4164C15.5528 17.8553 15.2236 18.414 15.0642 19.0398Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.41 15.0285C17.9288 14.1969 17.0303 13.6367 16.0003 13.6367C14.9703 13.6367 14.0717 14.1968 13.5906 15.0285C14.4677 15.0329 15.2902 15.2714 16.0003 15.6832C16.7103 15.2714 17.5327 15.0329 18.41 15.0285Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1902 16.6501C17.595 17.1015 17.916 17.6291 18.131 18.2077C18.534 17.7282 18.778 17.1108 18.7822 16.4364C18.6678 16.425 18.552 16.419 18.4347 16.419C17.9964 16.419 17.5769 16.5013 17.1902 16.6501V16.6501Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.418945)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKyrgyzstan);
export default __webpack_public_path__ + "static/media/kyrgyzstan.ea46121b.svg";
export { ForwardRef as ReactComponent };